import { DP_MODEL_METADATA_MAP } from "../constants/DpInferenceConfig";
import { EndpointType } from "../constants/Endpoints";
import { OCR_MODEL_METADATA_MAP } from "../constants/OcrInferenceConfig";
import { DpModelType } from "../types/dpInferenceConfig";
import { OcrModelType } from "../types/ocrInferenceConfig";

/**
 * 사용자 모델 접근 권한에 따라 접근 가능한 모델 목록을 필터링
 *
 * @param userModelAccessRole - 사용자 모델 접근 권한
 * @returns 접근 가능한 모델 목록
 */
export const getAccessibleModels = (
  userModelAccessRole: string,
  endpointType: EndpointType,
): (DpModelType | OcrModelType)[] => {
  const modelData = [
    ...Object.values(DP_MODEL_METADATA_MAP),
    ...Object.values(OCR_MODEL_METADATA_MAP),
  ];

  return modelData
    .filter(option => option.endpointType === endpointType)
    .filter(option => {
      // requiredRoles가 undefined면 모든 사용자에게 접근 가능
      if (!option.requiredRoles) {
        return true;
      }

      // requiredRoles가 있으면 해당 권한 중 하나라도 가진 사용자만 접근 가능
      return option.requiredRoles.includes(userModelAccessRole);
    })
    .map(option => option.apiName);
};
